import type { SingleSpaEvent } from "typings";

function getSeachParamsFromUrl(url: URL, outputUrl: URL) {
  for (let param of url.searchParams) {
    const [key, value] = param;
    outputUrl.searchParams.set(key, value);
  }
  return outputUrl;
}

export function assignBasename(pathnames: string[], basename: string) {
  window.addEventListener(
    "single-spa:before-routing-event",
    (evt: SingleSpaEvent<unknown>) => {
      const newUrl = new URL(evt.detail.newUrl);
      const oldUrl = new URL(evt.detail.oldUrl);

      function assingBasenameAndNavigates(pathname: string) {
        const shouldRedirect = newUrl.pathname.startsWith("/" + pathname);

        if (shouldRedirect) {
          let url = new URL(newUrl);
          url = getSeachParamsFromUrl(oldUrl, url);
          url.pathname = `/${basename}${url.pathname}`;
          window.location.assign(url);
          evt.detail.cancelNavigation();
        }
      }

      if (!newUrl.pathname.startsWith(`/${basename}`)) {
        pathnames.forEach(assingBasenameAndNavigates);
      }
    }
  );
}
